module.exports = __webpack_public_path__ + "media/honey-icons/receiver_single-a546df5a.svg";